import React, { Component } from 'react';
import Login from './components/Login/Login'
import { Route , Switch ,Redirect } from 'react-router-dom'
import Dashboard from './components/Admin/Dashboard/Dashboard'
import DepartmentList from './components/Common/Departments/DepartmentList'
import CollectionList from './components/Common/Collections/CollectionList'
import Users from './components/Admin/Users/UsersList';
import Logout from './components/Logout'
import NewCollectionItem from './components/Common/Collections/NewCollectionItem'
import auth from './components/services/authService'
import * as userService from './components/services/userService' 
import Files from './components/Common/Collections/Files';
import EditItem from './components/Common/Collections/EditItem';
import PwdReset from './components/Password-Reset/PwdReset';

class App extends Component {
  constructor(props){
    super(props)
    this.state = {
      data:{
          username:"",
          password:""
        },
        loginError: "",
        disabledBtn:false,
        user:{}
    }
  }

  
handleSubmit = e => {
    e.preventDefault()
    if (this.state.disabledBtn) {
       return;
   }
   this.setState({disabledBtn: true});
   this.submitForm()
}
hideMessage = () =>{
    this.setState({loginError:""})
}
handleChangeUsername = e =>{
    const data = {...this.state.data}
    data.username = e.currentTarget.value
    this.setState({data})
} 
handleChangePassword = e =>{
    const data = {...this.state.data}
    data.password = e.currentTarget.value
    this.setState({data})
}
submitForm = async() => {
    try {
      let { data } = this.state
      await auth.login(data.username , data.password)
      window.location = "/dashboard"
    } catch (ex) {
      if(ex && ex.response.status !==200){
        let loginError = {...this.state.loginError}
        loginError = ex.response.data.message
        this.setState({loginError})
        this.setState({disabledBtn:false})
    }   
  }
}
  render() { 
    let { loginError , disabledBtn , data } = this.state
    let currentUser = localStorage.getItem('currentUser')
    currentUser = JSON.parse(currentUser);
    return ( 
    <Switch>
       <Route path="/collections/createItem/:collection/:title/:id"  render={(props)=>{
          if(!currentUser) return <Redirect to ="/" />;
          return <NewCollectionItem {...props} />
        }      
       } />
       <Route path="/collections/items/:departmentId/:id/viewFiles"  render={(props)=>{
          if(!currentUser) return <Redirect to ="/" />;
          return <Files {...props} />
        }      
       } />
       <Route path="/collections/items/:departmentId/:title/:id/editItem"  render={(props)=>{
          if(!currentUser) return <Redirect to ="/" />;
          return <EditItem {...props} />
        }      
       } />
       <Route path="/departments/:id"  render={(props)=>{
          if(!currentUser) return <Redirect to ="/" />;
          return <CollectionList {...props} />
        }      
       } />
       <Route path="/departments" render={(props)=>{
          if(!currentUser) return <Redirect to ="/" />;
          return <DepartmentList {...props} />
       }      
       } />
       <Route path="/dashboard" render={(props)=>{
          if(!currentUser) return <Redirect to ="/" />;
          return <Dashboard {...props} />
       }      
       }/>
       <Route path="/users" render={(props)=>{
         
          if((currentUser && !currentUser.is_admin)){
            //code to return to the same page (Replace this code and insert codes to returns to the previous page)
            return <Redirect to ="/" />;
          }else if(!currentUser){
             return <Redirect to ="/" />;           
          }else{
            return <Users {...props} />
          }
        }      
       } />
       <Route path="/logout" render={(props)=><Logout {...props} />} />
       <Route path="/password-reset" render={(props)=><PwdReset {...props} />} />

       <Route path="/" exact render={(props)=><Login
       username = {data.username} 
       password = {data.password} 
       disabledBtn = {disabledBtn}
       loginError = {loginError}
       submitForm ={this.submitForm}
       handleSubmit = {this.handleSubmit}
       handleChangeUsername = {this.handleChangeUsername}
       handleChangePassword = {this.handleChangePassword}
       hideMessage={this.hideMessage}
       {...props}
       />}/>
       <Redirect to="/" />

    </Switch>
      
     );
  }
}
 
export default App;